module.exports = __webpack_public_path__ + "img/3.b2d37cc0.png";